var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89533 5.94L11.684 1.15452C11.9482 0.890519 11.9482 0.462 11.684 0.198C11.4198 -0.066 10.991 -0.066 10.7268 0.198L5.93817 4.98348L1.27626 0.324662C1.01208 0.0606619 0.583278 0.0606618 0.319102 0.324662C0.0549263 0.588662 0.0549263 1.01718 0.319102 1.28118L4.98102 5.94L0.198132 10.7197C-0.0660439 10.9837 -0.0660439 11.4122 0.198132 11.6762C0.462307 11.9402 0.891111 11.9402 1.15529 11.6762L5.93817 6.89652L10.8478 11.8029C11.112 12.0669 11.5408 12.0669 11.805 11.8029C12.0691 11.5389 12.0691 11.1104 11.805 10.8464L6.89533 5.94Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCloseIcon);
export default __webpack_public_path__ + "static/media/bannerCloseIcon.8206523361f8377bf215fee14db41774.svg";
export { ForwardRef as ReactComponent };